<sl-form-view [mainPageActions]="currentActions">
    @if (recordSummary(); as summary) {
        <mat-card>
            <mat-card-content class="container ml-0">
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'Address.Title' | translate }}</h2>
                        <p class="formatted-address">{{ summary.correspondenceAddress }}</p>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'Contact.Title' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Shareholders.Id' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ summary.id }}</span>
                            </div>
                        </div>

                        @if (!!summary.email) {
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'Contact.Email' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ summary.email }}</span>
                                </div>
                            </div>
                        }

                        @if (!!summary.mobileNumber) {
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'Contact.MobileNumber' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ summary.mobileNumber }}</span>
                                </div>
                            </div>
                        }
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'GMShareholders.GmInfo' | translate }}</h2>

                        <div class="row mb-3">
                            <div class="col-md-5">
                                <label class="font-weight-light">{{ 'GMShareholders.NumberOfShares' | translate }}</label>
                            </div>
                            <div class="col-md-7">
                                <span>{{ summary.numberOfShares }}</span>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-5">
                                <label class="font-weight-light">{{ 'GMShareholders.Votes' | translate }}</label>
                            </div>
                            <div class="col-md-7">
                                <span>{{ summary.votes }}</span>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-5">
                                <label class="font-weight-light">{{ 'GMShareholders.RegistrationStatus' | translate }}</label>
                            </div>
                            <div class="col-md-7">
                                <span>{{ summary.registrationStatusDescription }}</span>
                            </div>
                        </div>

                        @if (instructionNewAgendaItemDescriptionKey(); as instructionNewAgendaItemDescriptionKey) {
                            <div class="row mb-3">
                                <div class="col-md-5">
                                    <label class="font-weight-light">{{ 'GMShareholders.InstructionNewAgendaItem' | translate }}</label>
                                </div>
                                <div class="col-md-7">
                                    <span>{{ instructionNewAgendaItemDescriptionKey | translate }}</span>
                                </div>
                            </div>
                        }

                        @if (instructionAgendaItemChangeDescriptionKey(); as instructionAgendaItemChangeDescriptionKey) {
                            <div class="row mb-3">
                                <div class="col-md-5">
                                    <label class="font-weight-light">{{ 'GMShareholders.InstructionAgendaItemChange' | translate }}</label>
                                </div>
                                <div class="col-md-7">
                                    <span>{{ instructionAgendaItemChangeDescriptionKey | translate }}</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    }
</sl-form-view>
